



























import Vue from 'vue';
import moment from 'moment';
import 'moment/locale/nb'; // Norwegian Bokmål locale
import { createNamespacedHelpers, mapState as mapRootState } from 'vuex';
import DocumentList from './document/DocumentList.vue';
import { FollowUp } from '@/store/types';
const { mapGetters } = createNamespacedHelpers('grievanceItem');
const mapSessionState = createNamespacedHelpers('session').mapState;
export default Vue.extend({
    components: { DocumentList },
    props: {
        followUp: {
            type: Object,
            required: true,
        },
    },
    computed: {
        dateTimeString() {
            // Map 'no' to 'nb' for moment.js (Norwegian Bokmål)
            const momentLocale = this.locale === 'no' ? 'nb' : this.locale;
            moment.locale(momentLocale);
            return moment(this.followUp.date).format('LLL');
        },
        hasDocuments() {
            return !!this.followUp.documents?.length;
        },
        ...mapRootState(['locale']),
        ...mapGetters(['getFollowUpById']),
        ...mapSessionState(['recordId']),
    },
    methods: {
        getModuleId(followUp: FollowUp) {
            return followUp.id === 0 ? 'grievances' : 'follow_ups';
        },
        getItemId(followUp: FollowUp) {
            return followUp.id === 0 ? this.recordId : followUp.id;
        },
    },
});
